import { FieldInterface } from 'common/types/entities/field-interface'
import { changeField } from 'publisher/actions/optInActions'
import { useFieldsStorage } from 'publisher/components/entities/Field/hooks/use-fields-storage'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/opt-in/optInSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { BasePublisherCountryField } from 'src/publisher/entities/base-publisher-field/base-publisher-country-field'

type CountryFieldProps = {
  entity: FieldInterface
}

function CountryFieldNew({ entity }: CountryFieldProps) {
  const value = useOptIn(state => getFieldValueBySlug(state, entity.slug))
  const errors = useOptIn(state => getFieldErrorsBySlug(state, entity.slug))
  const dispatch = useDispatch()

  useFieldsStorage(entity.slug ?? '')

  return (
    <BasePublisherCountryField
      entity={entity}
      value={value}
      onChange={value => dispatch(changeField(entity.slug, value))}
      errors={errors}
    />
  )
}

export default CountryFieldNew
